import { CancelToken } from "axios";
import { useQuery } from "react-query";

import axios from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { ValuationTask } from "./types";

const getValuationTask = async (
  valuationTaskId: number,
  cancelToken?: CancelToken,
): Promise<ValuationTask> =>
  (
    await axios.get(`${ORDERBOOK_URL}/valuation-tasks/${valuationTaskId}`, {
      cancelToken,
    })
  ).data;

export const useValuationTask = (
  valuationTaskId: number,
  enabled: boolean,
  refetchInterval: number | false,
) =>
  useQuery(
    ["valuation-tasks", valuationTaskId],
    () => exported.getValuationTask(valuationTaskId),
    {
      enabled,
      refetchInterval,
    },
  );

const exported = {
  getValuationTask,
  useValuationTask,
};
export default exported;
